import { Box } from '@mui/material'
import SettingsPassword from './settings-password/settings-password.component'
import SettingsAddress from './settings-address/settings-address.component'
import SettingsTax from './settings-tax/settings-tax.component'
import SettingsLogo from './settings-logo/settings-logo.component'

const SettingsMyCompany = () => {
  return (
    <Box>
      <SettingsPassword />
      <SettingsAddress />
      <SettingsLogo />
      <SettingsTax />
      <Box sx={{ height: 150, backgroundColor: 'secondary.light' }}></Box>
    </Box>
  )
}

export default SettingsMyCompany
